import axios from 'axios'
export default {
  /**
   * Get all users of an Agency/Enterprise account.
   *
   * @function
   * @param params {Object} API query parameters.
   * @param params.search {String} Search string.
   * @return response {Promise} Request response.
   */
  get: (params) => axios.get(`/api/user/clients`, { params: params }),

  /**
   * Update an user.
   *
   * @function
   * @param id {Integer} Asset id.
   * @param params {Object} API query parameters.
   * @param params.name {String} New user name.
   * @param params.type {String} New user type.
   * @return response {Promise} Request response.
   */
  update: (id, params) => axios.put(`/api/user/clients/${id}`, params),

  /**
   * Delete an user account.
   *
   * @function
   * @param id {Integer} User id.
   * @return response {Promise} Request response.
   */
  remove: (id) => axios.delete(`/api/user/clients/${id}`),

  /**
   * Create a new user.
   *
   * @function
   * @param params {Object} API query parameters.
   * @param params.name {String} Array containing the asset files.
   * @param params.email {String} Array containing the asset metadata.
   * @param params.type {String} Asset name.
   * @return response {Promise} Request response.
   */
  create: (params) => axios.post(`/api/user/clients`, params),

  /**
   * Get all clients as options list.
   *
   * @function
   * @return response {Promise} Request response.
   */
  getAsOptions: () => axios.get(`/api/user/clients/options`),

  /**
   * PD-4886 — the employee users linked to a client, with what the given
   * whitelabel selection would change for each of them.
   *
   * @function
   * @param id {Integer} Account client id.
   * @param whitelabels {Array} The whitelabel ids about to be saved on the client.
   * @return response {Promise} Request response.
   */
  linkedEmployees: (id, whitelabels) => axios.get(`/api/user/clients/${id}/employees`, { params: { whitelabels: whitelabels || [] } }),

  /**
   * Get available client limits that can be assigned to a new client.
   *
   * @function
   * @return response {Promise} Request response.
   */
  getResources: (client) => axios.get(`/api/user/accounts/resources${client ? '/' + client : ''}`),

  /**
   * Get countries and industries options
   * 
   * @function
   * @returns response {Promise} Request response.
   */
  getCountriesIndustries: () => axios.get('/api/user/countries-industries'),
}
